var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{attrs:{"size":"34","color":"primary"}},[(
      _vm.authResult.checkin &&
      _vm.authResult.checkin[0] &&
      _vm.authResult.checkin[0].name &&
      _vm.authResult.checkin[0].name.length > 0
    )?_c('span',{staticClass:"white--text headline"},[_vm._v(_vm._s(_vm.authResult.checkin[0].name.charAt(0).toUpperCase()))]):_c('v-icon',{attrs:{"color":"white"}},[_vm._v("mdi-account-circle")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }